import { createFileRoute, Outlet, useNavigate } from "@tanstack/react-router";
import { useEffect } from "react";
import { useAuth } from "@/hooks/use-auth";
import { SidebarProvider, SidebarTrigger } from "@/components/ui/sidebar";
import { AdminSidebar } from "@/components/admin/AdminSidebar";

export const Route = createFileRoute("/admin")({
  component: AdminLayout,
  head: () => ({
    meta: [
      { title: "Admin · INFLOW Marketing" },
      { name: "description", content: "Internal admin dashboard for INFLOW Marketing." },
      { name: "robots", content: "noindex,nofollow" },
    ],
    links: [
      { rel: "preconnect", href: "https://fonts.googleapis.com" },
      { rel: "preconnect", href: "https://fonts.gstatic.com", crossOrigin: "anonymous" },
      { rel: "stylesheet", href: "https://fonts.googleapis.com/css2?family=Cormorant+Garamond:ital,wght@0,400;0,500;0,600;1,400;1,500&family=Inter:wght@300;400;500;600&display=swap" },
    ],
  }),
});

function AdminLayout() {
  const { isAdmin, loading, roleLoaded, signOut, user, session } = useAuth();
  const navigate = useNavigate();
  useEffect(() => {
    if (loading) return;
    if (!session) { navigate({ to: "/login" }); return; }
    if (roleLoaded && !isAdmin) navigate({ to: "/login" });
  }, [loading, session, roleLoaded, isAdmin, navigate]);

  if (loading || !roleLoaded || !isAdmin) {
    return <div className="admin-shell min-h-screen flex items-center justify-center text-muted-foreground">Loading…</div>;
  }

  const handleSignOut = async () => { await signOut(); navigate({ to: "/login" }); };

  return (
    <div className="admin-shell min-h-screen">
      <SidebarProvider>
        <div className="min-h-screen flex w-full">
          <AdminSidebar email={user?.email} onSignOut={handleSignOut} />
          <div className="flex-1 flex flex-col min-w-0">
            <header className="h-14 flex items-center border-b border-border px-4">
              <SidebarTrigger />
            </header>
            <main className="flex-1 px-6 py-8">
              <div className="max-w-7xl mx-auto">
                <Outlet />
              </div>
            </main>
          </div>
        </div>
      </SidebarProvider>
    </div>
  );
}
